import { createFileRoute, useNavigate, Link } from "@tanstack/react-router"
import { Send, Trash2, ArrowLeft } from "@/components/icons"
import { TopBarBackButton } from "@/components/topbar/TopBarBackButton"
import { AppLayout } from "@/components/AppLayout"
import { DesktopPage } from "@/components/desktop/DesktopPage"
import { DesktopPageHeader } from "@/components/desktop/DesktopPageHeader"
import { useIsDesktop } from "@/components/ui/use-mobile"
import { Card } from "@/components/ui/card"
import { MenuItem } from "@/components/ui/menu-item"

export const Route = createFileRoute("/_auth/profile/settings/helpandsupport")({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = useNavigate()
  const isDesktop = useIsDesktop()

  const handleContactSupport = () => {
    window.location.href = "mailto:support@pronteer.com"
  }

  const handleDeactivateAccount = () => {
    // TODO: Implement account deactivation flow
    console.log("Deactivate account requested")
  }

  const body = (
    <div className="flex flex-col gap-6">
        {/* Contact us Section */}
        <div>
          <p className="text-base font-semibold text-content-primary-bold mb-4 px-1">
            Contact us
          </p>
          <Card className="flex flex-col gap-2 w-full px-2">
            <MenuItem
              leftIcon={<Send />}
              size="large"
              onClick={handleContactSupport}
            >
              support@pronteer.com
            </MenuItem>
          </Card>
        </div>
      </div>
  )

  if (isDesktop) {
    return (
      <DesktopPage>
        <DesktopPageHeader
          title="Help & Support"
          breadcrumb={
            <span className="flex items-center gap-2">
              <button
                type="button"
                onClick={() => navigate({ to: "/profile/settings" })}
                className="flex size-7 items-center justify-center rounded-full hover:bg-surface-L1"
                aria-label="Back to settings"
              >
                <ArrowLeft className="size-4" />
              </button>
              <span>
                <Link to="/profile" className="hover:underline">
                  Profile
                </Link>
                <span className="text-content-primary-subtle"> / </span>
                <Link to="/profile/settings" className="hover:underline">
                  Settings
                </Link>
                <span className="text-content-primary-subtle"> / Help & Support</span>
              </span>
            </span>
          }
        />
        {body}
      </DesktopPage>
    )
  }

  return (
    <AppLayout topBar={<TopBarBackButton title="Help & Support" />}>
      {body}
    </AppLayout>
  )
}
